import useCampaignManagementStore from "@/store/campaignManagement";
import {isEmpty} from "lodash";
import {useEffect, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useEvent} from "react-use";
import {useIntercom} from "react-use-intercom";

let DATA = {};

const useIntercomCampaignSync = () => {
  const {t} = useTranslation();
  const {update} = useIntercom();

  const tabs = useMemo(
    (): {[key: string]: string} => ({
      overview: t("overview"),
      applications: t("applications"),
      removed: t("removed"),
      preparation: t("preparation"),
      active: t("active"),
      reporting: t("reporting"),
      gallery: t("gallery"),
      admin: t("admin"),
    }),
    [t],
  );

  useEvent("focus", () => {
    if (isEmpty(DATA)) return;
    update({customAttributes: {...DATA}});
  });

  useEffect(() => {
    const unsubscribe = useCampaignManagementStore.subscribe((state, prevState) => {
      if (state === prevState || !prevState.campaign || !state.campaign) return;
      const last_data: {
        refluenced_currently_opened_campaign_id: number;
        refluenced_currently_opened_campaign_title: string;
        refluenced_currently_opened_campaign_status: string;
        refluenced_currently_opened_campaign_currently_opened_tab: string;
        refluenced_currently_opened_campaign_has_partnership_ads_activated: boolean;
        refluenced_currently_opened_campaign_has_spark_ads_activated: boolean;
      } = {
        refluenced_currently_opened_campaign_id: state.campaign.id!,
        refluenced_currently_opened_campaign_title: state.campaign.title!,
        refluenced_currently_opened_campaign_status: state.campaign.status!,
        refluenced_currently_opened_campaign_currently_opened_tab: tabs[state.tabState],
        refluenced_currently_opened_campaign_has_partnership_ads_activated:
          state.campaign.instagram_branded_content_ads ?? false,
        refluenced_currently_opened_campaign_has_spark_ads_activated: state.campaign.tiktok_spark_ads ?? false,
      };

      update({customAttributes: {...last_data}});
      DATA = last_data;
    });

    return () => unsubscribe();
  }, []);
};

export {useIntercomCampaignSync};
